import React from 'react'
import {Translation, Translator} from '@morningtrain/react-translations'
import * as UI from 'ui/index'
import {ForEachModel, useModel, useValue} from '@morningtrain/react-resources'
import without from 'lodash/without'
import RoleSelectorForPermission from 'pages/app/settings/permissions/partials/RoleSelectorForPermission'
import * as Displays from 'support/displays'
import {ResourceSelector} from 'support/fields'

export default function DepartmentUsers() {
  return (
    <>
      <ResourceSelector
        name='selected_users'
        fromName='selected_users_list'
        resourceName='users.users'
        operationName='select'
        optionsKey='name'
        label={<Translation name='fields.employees_to_notify_about_late_order.label' />}
        multiple/>
    </>
  )
}
